import { useEffect } from "react";

const useInactivityTimeout = (onLogout, timeout = 600000) => {
  useEffect(() => {
    let timer;
    const resetTimer = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        onLogout();
      }, timeout);
    };
    const activityEvents = ["mousemove", "keydown", "scroll", "click"];
    activityEvents.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );
    resetTimer();
    return () => {
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
      if (timer) clearTimeout(timer);
    };
  }, [onLogout, timeout]);
};
export default useInactivityTimeout;